// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../doc-site/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../doc-site/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.bolt-colorswatchpicker .bolt-colorpip {
  cursor: pointer;
}
.bolt-colorswatchpicker .bolt-colorpip:hover .bolt-colorpip-content {
  box-shadow: 0 0 0 2px rgba( 255, 255, 255 ,  1 ), 0 0 0 5px rgba( 234, 234, 234 ,  1 );
  box-shadow: 0 0 0 2px rgba( var(--palette-neutral-0,255, 255, 255) ,  1 ), 0 0 0 5px rgba( var(--palette-neutral-8,234, 234, 234) ,  1 );
}

/*# sourceMappingURL=ColorSwatchPicker.css.map */
`, "",{"version":3,"sources":["webpack://./../azure-devops-ui/src/Components/ColorSwatchPicker/ColorSwatchPicker.scss","webpack://./../azure-devops-ui/bin/Components/ColorSwatchPicker/ColorSwatchPicker.css"],"names":[],"mappings":"AAEI;EACI,eAAA;ACDR;ADIY;EACI,sFAAA;ECFd,wIAAwI;AAC1I;;AAEA,gDAAgD","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
